// extracted by mini-css-extract-plugin
export default {"outer_wrapper":"Main_outer_wrapper__6OrLx","footer_row":"Main_footer_row__nXKms"};